import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { differenceInCalendarDays } from "date-fns";
import moment from "moment";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { AppsService } from "src/app/shared/services/apps.service";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CommonModule } from "@angular/common";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";

am4core.useTheme(am4themes_animated);
@Component({
  selector: "app-trips-cvrge-scndry-dashboard",
  templateUrl: "./trips-cvrge-scndry-dashboard.component.html",
  styleUrls: ["./trips-cvrge-scndry-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripsCvrgeScndryDashboardComponent implements OnInit {
  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) => this.onCellPrepared(this.columnDefs, e);

  header_label = {
    name: "Secondary Coverage Dashboard",
  };
  slctdDt = new Date();
  today = new Date();
  dateFormat = "dd/MM/yyyy";
  curDate;
  showLdr;
  clntDtls: any;
  userDtls: any;
  tdyCoveredTrips: any = [];
  dbrd_ky = "all";
  dbrd_typ = "scndry";
  tripsData: any = [];
  columnDefs: any = [];
  rowselected: any;
  curYr: string;
  toptripsData: any = [];
  topTripscolumnDefs: any = [];
  liveId: any;
  refresh_tm: string;
  ttlColumnDefs: any[];
  cvrge_prcnt: number;
  avg_cvrg: string;
  // Route & Trip status data
  ttlTrpsCnt: any = [];
  // Top 10 and Least 10 ULB coverages
  top10UlbData: any = [];
  least10UlbData: any = [];
  top10UlbColumnDefs: any = [];
  least10UlbColumnDefs: any = [];
  showTop10: boolean = true;
  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
  }

  ngOnInit(): void {
    this.curYr = moment(this.today).format("YYYY");
    setTimeout(() => {
      this.refresh();
    }, 1000);

    this.liveId = setInterval(() => {
      this.refresh();
    }, 15 * 60 * 1000);
  }
  refresh() {
    console.log("callled");
    const date = new Date();

    this.refresh_tm = moment(date).format("DD-MM-YYYY HH:mm:ss");
    if (this.liveId) {
      clearInterval(this.liveId);

      this.liveId = setInterval(() => {
        this.refresh();
      }, 15 * 60 * 1000);
    } else {
      this.liveId = setInterval(() => {
        this.refresh();
      }, 15 * 60 * 1000);
    }
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
    this.get_totalTripsCount();
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };
  onChange(e): void {
    this.slctdDt = e;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
    this.get_totalTripsCount();
  }
  getCoveredTripsCount(): any {
    this.tdyCoveredTrips = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/scndry/getCoveredTripsCount/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tdyCoveredTrips = res["data"];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getTripsData() {
    this.tripsData = [];
    this.ttlColumnDefs = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/scndry/getCoveredTripsDetails`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tripsData = res["data"];
          console.log(this.tripsData);
          this.cvrge_prcnt = 0;
          this.tripsData.forEach((e) => {
            this.cvrge_prcnt += e.coverage_per;
          });
          this.avg_cvrg = (this.cvrge_prcnt / this.tripsData.length).toFixed(2);
          console.log(this.avg_cvrg);

          // Compute Top 10 and Least 10 ULB coverages
          let sorted = [...this.tripsData].sort(
            (a, b) => (b.coverage_per || 0) - (a.coverage_per || 0)
          );
          this.top10UlbData = sorted
            .slice(0, 10)
            .map((e, i) => ({ ...e, sno: i + 1 }));
          this.least10UlbData = sorted
            .slice(-10)
            .reverse()
            .map((e, i) => ({ ...e, sno: i + 1 }));
          this.top10UlbColumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left" },
            {
              headerName: "Total Trips",
              field: "TOTAL_TRIPS",
              alignment: "center",
            },
            { headerName: "Completed", field: "OPERATED", alignment: "center" },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "center",
            },
          ];
          this.least10UlbColumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left" },
            {
              headerName: "Total Trips",
              field: "TOTAL_TRIPS",
              alignment: "center",
            },
            { headerName: "Completed", field: "OPERATED", alignment: "center" },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "center",
            },
          ];

          this.columnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
              fixed: true,
            },
            {
              headerName: "ULB",
              field: "ZONE",
              alignment: "left",
              fixed: true,
            },
            { headerName: "Total Vehicles", field: "TOT_VEHICLES" },
            { headerName: "Total Trips", field: "TOTAL_TRIPS" },
            {
              headerName: "Completed Trips",
              field: "OPERATED",
              alignment: "center",
            },
            {
              headerName: "Started Trips",
              field: "STARTED_TRIP",
              alignment: "center",
            },
            {
              headerName: "Route Deviated",
              field: "ROUTE_DEVIATED",
              alignment: "center",
            },
            {
              headerName: "Travel Distance(KM)",
              field: "trvl_dist",
              alignment: "center",
            },
            { headerName: "Coverage %", field: "coverage_per" },
          ];
        }
        this.ttlColumnDefs = [
          {
            headerName: "Total Vehicles",
            field: "TOT_VEHICLES",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Total Trips",
            field: "TOTAL_TRIPS",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Completed Trips",
            field: "OPERATED",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Started Trips",
            field: "STARTED_TRIP",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Route Deviated",
            field: "ROUTE_DEVIATED",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Travel Distance",
            field: "trvl_dist",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Coverage %",
            field: "coverage_per",
            alignment: "Center",
            summaryType: "avg",
            format: { type: "fixedPoint", precision: 2 },
          },
        ];

        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  onCellPrepared(colDef, e) {
    if (e.rowType === "data" && e.row.data && e.column.dataField == "ZONE") {
      e.cellElement.style.color = "rgb(0 142 255)";
      e.cellElement.style.fontWeight = 500;
      e.cellElement.style.borderRadius = "10px";
      e.cellElement.style.cursor = "pointer";
    }
  }
  devCellclk(devclmns, dvclkent) {
    if (dvclkent.columnIndex == 1) {
      if (dvclkent.data.ZONE != undefined) {
        this.rowselected = dvclkent.data;
        this.rowselected.slctdDt = this.slctdDt;
        this.TransfereService.setLoclData("ulbDta", this.rowselected);
        this.route.navigate([
          `internal/dashboard/scndrytripulbCvrge-dashboard`,
        ]);
      }
    }
  }
  // lst7DayDstnc;
  get_lst7DaysDistanceDta(): any {
    console.log("function called in secondary dashboard");
    let chart = am4core.create("coverageChart", am4charts.XYChart);
    chart.data = [];
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/scndry/trpsCvrgeLast7Days/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe((res) => {
      chart.data = res["data"];
      console.log(chart.data);
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "dt";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.title.text = ` ----- Date(${this.curYr})----- `;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      valueAxis.title.text = " ----- Covered % ----- ";
      chart.colors.list = [
        am4core.color("#f7babd"),
        // am4core.color("#7d64c4"),
      ];
      function createSeries(field, name) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "dt";
        series.name = name;
        series.columns.template.tooltipText =
          "{name} Vehicles in {categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.8;
        series.columns.template.height = am4core.percent(100);
        series.sequencedInterpolation = false;

        let columnTemplate1 = series.columns.template;
        columnTemplate1.strokeWidth = 1;
        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueY}";
        valueLabel.label.fontSize = 15;
        valueLabel.label.dy = 10;
        columnTemplate1.column.cornerRadiusTopLeft = 5;
        columnTemplate1.column.cornerRadiusTopRight = 5;
        columnTemplate1.strokeOpacity = 1;

        let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
      }

      createSeries("coverage_per", "Coverage");
    });
  }
  getTop5Trips() {
    this.toptripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/scndry/getTop10Coverages/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.toptripsData = res["data"];

          this.topTripscolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left", width: 200 },
            {
              headerName: "Vehicle",
              field: "asrt_nm",
              alignment: "left",
              width: 200,
            },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "Center",
              width: "auto",
            },
          ];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  // onExporting1() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  // onExporting2() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  get_totalTripsCount() {
    this.ttlTrpsCnt = [];
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    let postData: any = {
      dt: this.curDate,
    };
    let rte = `dashboard/enterprise/ttlTrips/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        let data = res["data"];
        if (data && data.length > 0) {
          this.ttlTrpsCnt = [
            {
              rts_dfnd: data[0].secondary_rts_dfnd || 0,
              rts_not_dfnd:
                (data[0].secondary_def_trps || 0) -
                (data[0].secondary_rts_dfnd || 0),
              trvl_trps: data[0].secondary_trvl_trps || 0,
              def_trps: data[0].secondary_def_trps || 0,
              nt_trvl_trps:
                (data[0].secondary_def_trps || 0) -
                (data[0].secondary_trvl_trps || 0),
            },
          ];
        }
      },
      (err) => {}
    );
  }

  // onExportingTop10Ulb() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  // onExportingLeast10Ulb() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  ngOnDestroy() {
    clearInterval(this.liveId);
  }
}
